// News posts, newest first. The slug is the URL (/news/:slug); links from other sites point at
// these, so never change an existing slug.
import BumpModelLaunch from './postBodies/BumpModelLaunch';
import BumpupsApi from './postBodies/BumpupsApi';
import LocalAndYouTubeSupport from './postBodies/LocalAndYouTubeSupport';
import NewBumpups from './postBodies/NewBumpups';
import bump1_cover from '../../assets/images/blog/blog-bump-1.jpg';
import api_cover from '../../assets/images/blog/blog-bumpups-api-cover.jpg';
import yt_local_cover from '../../assets/images/blog/blog-localYTsupport-asset.jpg';
import new_bumpups_cover from '../../assets/images/blog/blog-new-bumpups-cover.jpg';

export const POSTS = [
  {
    slug: 'meet-the-bumpups-api',
    title: 'Meet the Bumpups API: Chapters and Answers From Your Own Code',
    category: 'Product',
    date: '2026-10-09',
    cover: api_cover,
    coverAlt: 'The Bumpups API page: a YouTube link sent to the API and the chapters it returns',
    description: 'Bumpups Pro now includes an API. Send a YouTube link from your own code, get timestamped chapters back, and ask questions about the video, with the same minutes as the app.',
    Body: BumpupsApi,
  },
  {
    slug: 'meet-the-new-bumpups',
    title: 'Meet the New Bumpups: Chats That Remember and a Whole New Look',
    category: 'Product',
    date: '2026-09-26',
    cover: new_bumpups_cover,
    coverAlt: 'The new Bumpups workspace, with a follow-up question in the chat',
    description: 'Every workspace chat is now a real conversation that remembers what you asked, so you can follow up and build on any answer. And all of Bumpups has a brand-new look.',
    Body: NewBumpups,
  },
  {
    slug: 'introducing-bump-10-model',
    title: 'Introducing Bump-1.0 Model',
    category: 'Announcements',
    date: '2025-04-19',
    cover: bump1_cover,
    coverAlt: 'bump-1.0',
    description: 'Introducing bump-1.0, an innovative AI model that transforms raw video content into actionable insights. Discover how its seamless integration and cutting-edge performance revolutionize video analysis for developers and businesses alike.',
    Body: BumpModelLaunch,
  },
  {
    slug: 'local-and-youtube-video-handling-supported',
    title: 'Local and YouTube Video Handling Supported',
    category: 'Product',
    date: '2024-11-25',
    cover: yt_local_cover,
    coverAlt: 'Local and YouTube video handling',
    description: 'Our platform now supports both local video uploads and YouTube video analysis, enabling seamless processing of content from multiple sources.',
    Body: LocalAndYouTubeSupport,
  },
];

export const postBySlug = slug => POSTS.find(p => p.slug === slug);

export const formatPostDate = iso => new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  .format(new Date(`${iso}T00:00:00Z`));
